import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTaskAndReview, updateTaskAndReview } from 'api/task.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { Task } from 'models/task.model';
import { useNavigate } from 'react-router-dom';
import { resetDraft } from 'store/task.store';

export const useTaskConditionalReviewQuery = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading: isDraftLoading } = useMutation(
    (payload: { task: Task; new: boolean }) =>
      payload.new
        ? createTaskAndReview(payload.task)
        : updateTaskAndReview(payload.task),
    {
      retry: false,
      cacheTime: Infinity,
      onSuccess: async (task) => {
        resetDraft();
        queryClient.invalidateQueries(['tasks']);
        toast.success('Task sent for review successfully');
        navigate(`/tasks/${task.id}`);
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  const isLoading = isDraftLoading;

  return { isLoading, mutate };
};
